module.exports = "<app-route-edit-template on-cancel=$ctrl.cancel() on-save=$ctrl.save() route=$ctrl.route switch-tab-prefix=app.routecreate> </app-route-edit-template> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/route/create/partial.html
// module id = 460
// module chunks = 0